
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"137","height":"87","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.989 4.527a.506.506 0 01.352-.287l.431-.106c.173-.114 11.02-2.18 11.02-2.18.243-.06.476.052.528.254.053.2-.11.426-.333.495L7.442 4.545c6.963 1.375 25.118 5.469 46.193 14.26 24.811 10.351 58.874 29.52 80.246 62.057.197.301.054.71-.32.915a.95.95 0 01-.16.068c-.337.11-.705.016-.875-.243C111.328 49.329 77.518 30.3 52.887 20.02 31.548 11.113 13.243 7.058 6.622 5.767l5.066 5.062c.136.16.091.399-.103.543a.56.56 0 01-.159.081.481.481 0 01-.47-.08L3.072 4.905a.331.331 0 01-.082-.38","stroke":"#FFF","stroke-width":".7","stroke-linecap":"square","fill":"#FFF"}})])
          )
        }
      }
    